<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="width: 70%;">
                <div class="modal-header">
                    <h3 class="form-header">PRN Administration</h3>
                    <button @click="closeModal()" class="red-close-button">
                        <i class="pi pi-times" style="padding: 0"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <form class="action-modal">
                            <!-- BASIC INFO -->
                            <!-- BASIC INFO -->
                                <div class="form-section-container" style="grid-template-columns: 3fr 4fr 4fr; grid-gap: 24px; width: 100%; padding: 0 25px;">

                                <div class="left-form-section-panel" style="padding: 0;" v-if="!selectedPRN.sliding_scale.length">
                                    <div class="icon-container">
                                        <div class="icon-circle">
                                            <img class="icon-circle-item" src="../../assets/icons/medIconWhite.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div class="left-form-section-panel" style="padding: 0;" v-else>
                                    <h4 style="text-align: left; margin: 0; margin-bottom: 10px;">
                                        Sliding Scale
                                    </h4>
                                    <div
                                        v-for="(item, index) in selectedPRN.sliding_scale"
                                        :key="index"
                                        style="display: flex; padding: 5px; align-items: center; width: 10em; justify-content: space-between"
                                    >
                                        <p style="font-size: 1em; width: 5em; text-align: right">
                                            {{item.min}} {{item.max ? '-' : '+'}} {{item.max}}: 
                                        </p>
                                        <!-- :style="selectedIndex == index ? {backgroundColor: '#00AD50', color: 'white'}:{}" -->
                                        <p style="font-size: 1em; font-weight: bold; margin-left: 20px; background-color: #f3f4f4; border-radius: 4px; padding: 5px 10px; width: 50px;">
                                            {{item.value}}
                                        </p>
                                    </div>
                                    <div class="small-input" style="margin: 10x; margin-left: 0px; margin-bottom: 15px; width: fit-content">
                                        <p style="text-align: left; margin: 0; font-size: 1em; margin-top: 10px; margin-bottom: 5px;">
                                            Enter {{readingUnitLabel}} Reading:
                                        </p>
                                        <InputNumber
                                            :minFractionDigits="0"
                                            :maxFractionDigits="2"
                                            v-tooltip.right="'Reading'"
                                            mode="decimal"
                                            style="border: 1px solid grey; border-radius: 4px; width: 5em;"
                                            v-model="enteredReading"
                                            @focus="$event.target.select()"
                                        />
                                    </div>
                                    <div class="blue-button" @click="addReading()" :style="(dangerWarningMessage && !acknowledgeDangerReading) ? {backgroundColor: 'grey', cursor: 'not-allowed'} : {}">
                                        Submit Readings
                                    </div>
                                </div>
                                <div class="left-form-section-panel" style="padding: 0;">
                                    <div class="grey-container">
                                        <p>
                                            <b>Route: </b>{{selectedPRN.route}}
                                        </p>
                                        <p>
                                            {{selectedPRN.instructions.split('-------Please write any additional notes below this line-------').join('')}}
                                        </p>
                                        <p>
                                            <b>Indication:</b> {{selectedPRN.indication ? selectedPRN.indication : 'Not provided.'}}
                                        </p>
                                        <p v-if="overDailyMax" style="color: #E04F39; font-weight: bold;">
                                            <b>Max dose 24hrs:</b> <span v-if="selectedPRN.max_dose">{{selectedPRN.max_dose}} {{selectedPRN.dose_unit}}{{selectedPRN.max_dose > 1 ? 's':''}}</span> <span v-else>Not provided.</span>
                                        </p>
                                        <p v-else>
                                            <b>Max dose 24hrs:</b> <span v-if="selectedPRN.max_dose">{{selectedPRN.max_dose}} {{selectedPRN.dose_unit}}{{selectedPRN.max_dose > 1 ? 's':''}}</span> <span v-else>Not provided.</span>
                                        </p>
                                        <p>
                                            <b>Last Event:</b> <span v-if="selectedPRN.last_chart_administrations.length">{{selectedPRN.last_chart_administrations[0]?.administered_at}}</span>
                                            <span v-else>Never administered.</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="right-form-section-panel" style="padding: 0;">
                                    <div>
                                        <h3 class="form-header">{{selectedPRN.alias.name}}</h3>
                                        <div style="margin: 10x; margin-left: 0px; margin-bottom: 15px; ">
                                            <div v-if="selectedPRN.stock_items?.length && selectedPRN.stock_items[0]?.name">
                                                <!-- IF SINGLE ITEM -->
                                                <p style="font-size: 1em; text-align: left" v-if="selectedPRN.stock_items.length == 1"><b>Dispensed drug:</b> {{selectedPRN.stock_items[0].alias.name}}</p>
                                                <!-- IF MULTIPLE ITEMS -->
                                                <div v-else style="display: grid; grid-gap: 5px; align-items: start;">
                                                    <p style="font-size: 1em; text-align: left; margin-bottom: 0;"><b>Confirm dispensed drug: </b></p>
                                                    <Dropdown v-model="selected_stock_item" :options="selectedPRN.stock_items" optionLabel="name"
                                                    
                                                    :placeholder="selected_stock_item ? selected_stock_item.alias.name : 'Select drug'" />
                                                </div>
                                            </div>
                                            <div style="display: flex; flex-direction: column; align-items: start">
                                                <p style="text-align: left; margin: 0; margin-top: 20px">
                                                Enter Quantity ({{selectedPRN.dose_unit}}{{selectedPRN.dose > 1 ? 's':''}}) - {{ doseContainerQty }} {{ selectedPRN.container_unit }}{{doseContainerQty > 1 ? 's':''}}
                                                </p>
                                                <InputNumber
                                                    :minFractionDigits="0"
                                                    :maxFractionDigits="2"
                                                    v-tooltip.right="'Prescription Quantity'"
                                                    mode="decimal"
                                                    style="border: 1px solid grey; border-radius: 4px; "
                                                    v-model="enteredDose"
                                                    @focus="$event.target.select()"

                                                />
                                            </div>
                                            <div v-if="overDoseLimit || frequencyBlockedMessage" style="width: 100%; margin-top: 10px; display: flex; flex-direction: column; gap: 4px; text-align: left;">
                                                <p v-if="overDoseLimit" style="margin: 0; color: #E04F39; font-weight: bold;">
                                                   Entered dose will exceed max dose limit
                                                </p>
                                                <!-- S8 medications are audited, so exceeding the prescribed max frequency is refused
                                                     outright - no acknowledgement can override it, unlike other medications. -->
                                                <p v-if="frequencyBlockedMessage" style="margin: 0; color: #E04F39; font-weight: bold;">
                                                   {{ frequencyBlockedMessage }}
                                                </p>
                                            </div>
                                            <div v-if="dangerWarningMessage" style="width: 100%; margin-top: 10px; padding: 10px; background-color: #fdecea; border: 1px solid #E04F39; border-radius: 4px; box-sizing: border-box;">
                                                <p style="margin: 0; color: #E04F39; font-weight: bold; font-size: 0.9em; text-align: left;">
                                                    <i class="pi pi-exclamation-triangle" style="margin-right: 5px;"></i>{{ dangerWarningMessage }}
                                                </p>
                                                <div style="display: flex; align-items: center; margin-top: 8px;">
                                                    <Checkbox v-model="acknowledgeDangerReading" :binary="true" inputId="ackDangerReadingPrn" />
                                                    <label for="ackDangerReadingPrn" style="margin-left: 8px; font-size: 0.85em; text-align: left;">I acknowledge this warning</label>
                                                </div>
                                            </div>

                                        </div>
                                        <div v-if="selectedPRN.sliding_scale.length">
                                            <p style="font-size: 1em; text-align: left">
                                                Last reading: <b>{{savedReading ? savedReading.value: readings.length ? readings[0].value :  'No reading taken'}}</b>
                                            </p>
                                            <p style="font-size: 1em; text-align: left">
                                                Time of last reading: {{savedReading ? savedReading.date : readings.length ? readings[0].created_at :  'N/A'}}
                                            </p>
                                        </div>
                                    </div>
                                    <!-- <div style="background-color: rgb(229, 241, 254);border-radius: 6px;">
                                        <p class="note-header" style="margin: 0; padding-bottom: 5px;">
                                            Notes
                                        </p>
                                        <textarea
                                            class="noresize"
                                            name="notes"
                                            id="note-modal"
                                            rows="11"
                                            placeholder="Enter notes here..."
                                            style="width: 100%;border-radius: 6px; border-top-right-radius: 0px; border-top-left-radius: 0px; border: none; background-color: #E5F1FE; padding: 0 8px;"
                                            v-model="notes">
                                        </textarea>
                                    </div> -->
                                </div>
                            </div>
                        </form>
                    </slot>
                </div>

                <div class="modal-footer" style="display: flex; align-items: center; justify-content: flex-end; gap: 16px; padding: 10px 20px;">
                    <slot name="footer" style="display: flex;">
                        <!-- The S8 frequency block is unacknowledgeable, so it must stop the nurse before they
                             physically retrieve the drug from the safe, not just at the final Sign step. -->
                        <p v-if="frequencyBlockedMessage" style="color: #E04F39; font-weight: bold; text-align: right; margin: 0;">
                            {{ frequencyBlockedMessage }}
                        </p>
                        <SingleVerify
                            @click="()=>{removeDrugFromRegister(selectedPRN)}"
                            v-else-if="selectedPRN?.stock_items?.length && !selectedPRN.removed"
                            :isPRN="true"
                            @getDrugId="getPRNId"
                            :payload="removeFromRegisterPayload"
                            endpoint="/drug-safe-retrieval"
                            :drugSafeRemoval="true"
                            :dual="true"
                            :id="selectedPRN?.uuid"
                            :textRemoveButton="true"
                            :notes="notes"
                            :discardAvailable="discardAvailable"
                            :stock_items="selectedPRN?.stock_items"
                        />
                        <button v-else class="green-button" style="flex-shrink: 0;" @click="signAction()" :disabled="signDisabled" :style="signDisabled ? {backgroundColor: 'grey', cursor: 'not-allowed'} : {}">
                           Sign
                        </button>
                    </slot>
                </div>
            </div>
        </div>
        <!-- Require Dual Signature for any S8 PRN meds -->
        <SignatureModal
            v-if="displaySignatureModal"
            @isSuccessful="isSuccessful"
            :payload="payload"
            @close="closeSignatureModal"
            :dual="requiresDoubleSig || enteredReading"
            :endpoint="signature_endpoint"
            @getDrugId="getPRNId"
            :noAuthRequired="noAuthRequired"
            :loop="loop"
            :displayReason="true"
        />
        <SuccessModal
            v-if="displaySuccessModal"
            :first_spec_line="displayMessage"
            @close="closeSuccessModal"
        />
    </div>
</template>

<script>
import SignatureModal from './SignatureModal.vue';
import SingleVerify from '@/components/verification/SingleVerify.vue';
import SuccessModal from './SuccessModal.vue';
import axios from 'axios';
import { isProxy, toRaw } from 'vue';
import { tagsInclude } from '@/services/doubleSignature';
import { isWarfarinOrInrChart, getSafeRangeFromSlidingScale, isReadingOutsideRange, selectSlidingScaleBandIndex, readingIdentityForChart } from '@/services/slidingScale';


export default {
    props: [
        'message',
        'close',
        'loading',
        'statusMessage',
        'action',
        'actionType',
        'noAuthRequired',
        'adminSubmission',
        'loop',
        'selectedPRN',
        'patientId',
        'readings',
        ''
    ],
    components: {
        SignatureModal,
        SingleVerify,
        SuccessModal
    },
    data() {
        return {
            selected_stock_item: null,
            displaySuccessModal: false,
            displayMessage:'',
            payload:'',
            discardAmount:0,
            discardAvailable:false,
            // enteredDose: this.selectedPRN && this.selectedPRN.sliding_scale && !this.selectedPRN.sliding_scale.length ? parseFloat(this.selectedPRN.dose) : 0,
            enteredDose: 0,
            // doseContainerQty:0,
            enteredReading:0,
            acknowledgeDangerReading: false,
            savedReading: null,
            selectedIndex: 0,
            signature_endpoint:'/administer-chart',
            displaySignatureModal: false,
            removeFromRegisterPayload: [],
            removedFromRegister: false,
            drug_safe_retrieval:'',
            selectedCode:'',
            notes:'',
            doseOmittedCode:[
            {value:  'A',
              label:'Absent'
            },
            {value:  'F',
              label:'Fasting'
            },
            {value:  'H',
              label:'Hospital'
            },
            {value:  'L',
              label:'On Leave'
            },
            {value:  'S',
              label:'Sleeping'
            },
              {value:'S/A',
                  label:'Self Administration'
                },
            {value:  'V',
              label:'Vomiting'
            },
              {value:'A/T',
                  label:'Adjusted Administration'
                },
            {value:  'C',
              label:'Contraindicated'
            },
            {value:  'N',
              label:'Not available'
            },
              {value:'N/R',
                  label:'Not Required'
                },
            {value:  'O',
              label:'Omitted'
            },
            {value:  'R',
              label:'Refused'
            },
            {value:  'W',
              label:'Withheld (clinical)'
            },
              {value:'W/R',
                  label:'Withheld (pending results)'
                },
            ]
        }
    },
    methods: {
        recommendedSlidingDose() {
            // `savedReading` first - this is re-run straight after addReading(), before the
            // parent's copy of the readings list is guaranteed to be in play.
            let lastReading = null;
            if (this.savedReading) {
                lastReading = this.savedReading.value;
            } else if (this.readings && this.readings.length) {
                lastReading = this.readings[0].value;
            }

            if (lastReading === null) return;
            // Band selection is numeric and lives in slidingScale.js - see the comment there for
            // why comparing these values as-is picks the wrong dose band. It also tolerates a PRN
            // with a missing or empty sliding_scale, which this is called with unconditionally
            // from mounted().
            const index = selectSlidingScaleBandIndex(this.selectedPRN?.sliding_scale, lastReading);
            if (index !== null) {
                this.selectedIndex = index;
            }
        },
        addReading() {
            // Guard against an empty reading - the InputNumber sets the model to null
            // when cleared, and enteredReading.toString() below would throw.
            if (this.enteredReading === null || this.enteredReading === undefined || this.enteredReading === '') {
                this.displayMessage = 'Please enter a reading before submitting.';
                this.displaySuccessModal = true;
                return;
            }
            // CLINICAL DANGER THRESHOLD CHECK: blocks submission of a dangerously elevated/flagged
            // reading until the user has explicitly acknowledged the warning shown in the UI.
            if (this.dangerWarningMessage && !this.acknowledgeDangerReading) {
                this.displayMessage = `${this.dangerWarningMessage} Please acknowledge the warning above before submitting.`;
                this.displaySuccessModal = true;
                return;
            }

            this.$store.dispatch('getRefreshToken');
            this.displaySuccessModal = true;
            const reading = readingIdentityForChart(this.selectedPRN);
            this.displayMessage = `Updating ${reading.unit} reading.`;
            let payload = {
                patient_id:this.patientId,
                unit: reading.unit,
                type: reading.type,
                // Sent (and kept) as a number - see SlidingScaleAdminModal for why stringifying
                // this broke the downstream sliding scale band comparison.
                value: this.enteredReading
            }
            console.log('this is the payload for reading', payload);
            axios.post('/create-reading', payload, this.$store.state.header)
            .then(res => {
                console.log(res);
                delete payload.patient_id;
                this.displayMessage = 'Successfully updated reading.';
                res.data.value = this.enteredReading;
                console.log('emitting this create reading res', res.data);
                this.savedReading = {
                    value: this.enteredReading,
                    date: res.data.created_at,
                    id: res.data.uuid
                };
                this.$emit('addInsulinReading', res.data);
                this.acknowledgeDangerReading = false;
                setTimeout(() => {
                    this.displaySuccessModal = false;
                    this.recommendedSlidingDose();
                }, 1000)
            }).catch(err => {
                this.displayMessage = err.response.data
            })
        },
        closeSuccessModal(value) {
            if (value) {
                this.displaySuccessModal = false;
            }
        },
        removeDrugFromRegister(drug) {
            let discard_amount = parseFloat(Math.ceil(this.doseContainerQty) - this.doseContainerQty).toFixed(2);
            let qty = parseFloat(this.doseContainerQty).toFixed(2);
                
            if(discard_amount > 0){
                console.log("discard amount is greater than 0: " + discard_amount);
            }else{
                console.log("discard amount is not greater than 0: " + discard_amount);
            }

            this.removeFromRegisterPayload = 
                {
                    prescriber_uuid:drug.prescriber_id,
                    stock_item_id: this.selected_stock_item.uuid,
                    quantity: qty.toString(),
                    patient_id: this.patientId,
                    dose_quantity: this.enteredDose,
                    dose_unit: drug.dose_unit,
                    ...((discard_amount > 0) && { discard_amount: discard_amount.toString() }), // conditionally adds discard_amount to payload
                }
                
            this.discardAvailable = discard_amount > 0 ? discard_amount + " " + drug.container_unit + "/s" : false;
        },
        getPRNId(value) {
            console.log('HIT THE DRUG SAFE RETRIEVAL ID IN SINGLEVERIFY', value);
            this.$store.dispatch('getRefreshToken');
            this.$emit('updatePRN', value);
            this.removedFromRegister = true;
            this.drug_safe_retrieval = value.drug_safe_retrieval;
        },
        cancelAction() {
            this.$emit('stopAction', true);
            this.$emit('close', true);
        },
        isSuccessful(value) {
            if (value) {
                console.log('this is the value from administering prns', value);
                this.displaySignatureModal = false;
                this.$emit('successfullySubmitted', true);
                this.$emit('completePRN', {administered_at: value.administered_at, id: this.selectedPRN.uuid});
                this.closeModal();
            }
        },
        signAction() {
            // S8 max-frequency block cannot be overridden, unlike the other warnings below.
            if (this.frequencyBlockedMessage) {
                return;
            }
            // Mirrors the guard in addReading() — a nurse can type a dangerous/out-of-range reading
            // and click Sign directly without ever pressing "Submit Reading", which would otherwise
            // bypass the warning entirely.
            if (this.dangerWarningMessage && !this.acknowledgeDangerReading) {
                return;
            }
            this.displaySignatureModal = true;
            let date = new Date();
            // not technically this.adminSubmission.calendar_item_id but is being passed via prop as such, it is indeed the chart_id;
            let notes = `PRN dose administered.

Date: ${date.toLocaleDateString('en-AU')}
Time of administration: ${date.toLocaleTimeString('en-AU')}
Drug name: ${this.selectedPRN.alias.name}
Dose: ${this.enteredDose} ${this.selectedPRN.dose_unit}/s ${(this.selectedPRN.container_unit.toLowerCase() === 'ampoule' && this.selectedPRN.container_unit.toLowerCase() !== this.selectedPRN.dose_unit.toLowerCase()) ? '[' + this.doseContainerQty + ' Ampoule(s)' + ']': ''}
Administration Route: ${this.selectedPRN.route}
${this.enteredReading ? 'Reading : '+this.enteredReading : ''}
`
            this.payload = {
                chart_id:this.adminSubmission.calendar_item_id,
                doc:'',
                notes:notes,
                dose: this.enteredDose.toString(),
                drug_safe_retrieval: this.drug_safe_retrieval ? this.drug_safe_retrieval : this.adminSubmission.drug_safe_retrieval,
                reading: this.savedReading ? this.savedReading.id : this.readings && this.readings.length ? this.readings[0].uuid :''
            }
            console.log('SIGN ACTION CONDITION', this.payload);
            console.log('SIGN ACTION HITTING ELSE THEN ELSE CONDITION');
            
            console.log('this is the payload', this.payload);
        },
        closeSignatureModal(value) {
            if (value) {
                this.displaySignatureModal = false;
            }
        },
        closeModal() {
            console.log('hitting this closemodal function');
            if (this.reloadPageOnClose == true) {
                this.$emit('close', 'reload');

            } else {
                this.$emit('close', true);

            }
        },
    },
    // watch:{
    //     enteredDose(newValue){
    //         let containerConstant = this.selectedPRN?.container_constant ?? 1
    //         let myQty = parseFloat(newValue / containerConstant);

    //         this.doseContainerQty = myQty.toFixed(2);

    //         this.discardAmount = parseFloat(Math.ceil(myQty) - myQty);
            
            
    //     }
    // },
    computed: {
        // Administering a PRN is only a legislative dual-signature event for S8. S4/S4Vic and
        // facility-nominated tags govern drug safe/register movements - the retrieval leg above
        // is always dual - but must not force a witness onto the administration itself.
        // Insulin is a separate, independent dual-signature trigger.
        requiresDoubleSig() {
            return this.isS8 || tagsInclude(this.selectedPRN?.alias?.tags, 'insulin');
        },
        overDailyMax() {
            return (this.dailydose + this.enteredDose) > this.selectedPRN?.max_dose;
        },
        overAdminMax() {
            return this.enteredDose > this.selectedPRN?.max_admin_dose;
        },
        overDoseLimit() {
            return this.overDailyMax || this.overAdminMax;
        },
        // Gates the Sign button on every reason administration should stop: dose-limit math,
        // an unacknowledged warning (INR/frequency for non-S8 meds), or an outright S8 frequency block.
        signDisabled() {
            const dangerBlocked = !!(this.dangerWarningMessage && !this.acknowledgeDangerReading);
            return this.overDoseLimit || dangerBlocked || !!this.frequencyBlockedMessage;
        },
        isWarfarinOrINR() {
            return isWarfarinOrInrChart(this.selectedPRN);
        },
        // Label the input with the unit the reading will actually be stored as, so the prompt can't
        // drift from what addReading() persists.
        readingUnitLabel() {
            return readingIdentityForChart(this.selectedPRN).unit;
        },
        // The safe range a reading is checked against is entirely defined by the prescriber's
        // sliding scale bands (Min/Max) - there is no separate hardcoded clinical threshold.
        inrRange() {
            return getSafeRangeFromSlidingScale(this.selectedPRN.sliding_scale);
        },
        inrRangeMin() {
            return this.inrRange.min;
        },
        inrRangeMax() {
            return this.inrRange.max;
        },
        isOutsideInrRange() {
            if (!this.isWarfarinOrINR) return false;
            return isReadingOutsideRange(this.enteredReading, this.inrRange);
        },
        // This is the gate for the one block that cannot be acknowledged away (see
        // frequencyBlockedMessage below), so it's the check that most needs the same
        // case-insensitive, object-shape-tolerant tag matching used everywhere else - a raw
        // `.includes('s8')`/`.includes('S8')` here would miss `{ name: 'S8' }` tag objects and
        // any other casing (e.g. 's8', 'S8 ').
        isS8() {
            return tagsInclude(this.selectedPRN?.alias?.tags, 's8');
        },
        // last_chart_administrations includes refused/omitted/withheld events (doc set) alongside
        // real administrations - only actual administrations (doc unset) count toward frequency limits.
        // The backend type is Vec<Option<ChartAdministration>> - a null element is possible, and
        // `.filter(Boolean)` drops it before `!admin.doc` is evaluated, since `null.doc` would throw
        // and break this computed (which feeds signDisabled/dangerWarningMessage/frequencyBlockedMessage,
        // so a single null entry would otherwise break the entire admin modal render).
        actualAdministrations() {
            return (this.selectedPRN?.last_chart_administrations || [])
                .filter(Boolean)
                .filter(admin => !admin.doc);
        },
        // Whether this PRN has already reached its prescribed max administrations per day.
        // Marking a prior dose "ineffective" only updates the effectiveness field, it doesn't remove
        // the dose from the frequency count, so it cannot be used to bypass this limit.
        isOverMaxFrequency() {
            const maxAdmin = parseFloat(this.selectedPRN?.max_times_per_day);
            // max_times_per_day defaults to 0 when a prescriber leaves it unset (PrescriptionChart.vue),
            // which must mean "no daily cap configured", not "administer zero times".
            if (isNaN(maxAdmin) || maxAdmin <= 0) return false;
            return this.actualAdministrations.length >= maxAdmin;
        },
        // S8s are audited and carry real safety/regulatory risk, so exceeding the prescribed frequency
        // is refused outright here - no acknowledgement can override it. Other medications have
        // legitimate cases for a second dose (reviewed via audit), so those only get a warning below.
        frequencyBlockedMessage() {
            if (this.isS8 && this.isOverMaxFrequency) {
                return `This S8 medication has already been administered ${this.selectedPRN.max_times_per_day} time(s) in the last 24 hours. Administration is blocked — contact the prescriber.`;
            }
            // Fail CLOSED for S8: if we have a last administration but can't verify how long ago it
            // was, block rather than silently allow (this only applies when the frequency shorthand
            // implies a minimum gap between doses, e.g. "4 Hourly").
            if (this.isS8 && this.frequencyIntervalHours !== null && this.hasUnverifiableLastAdministrationTime) {
                return `This S8 medication's last administration time could not be verified. Administration is blocked until confirmed manually — contact the prescriber or check the administration history.`;
            }
            if (this.isS8 && this.isWithinScheduledWindow) {
                return `This S8 medication was last administered at ${this.lastAdministrationTime.toLocaleString('en-AU')} and cannot be given again within its prescribed ${this.frequencyIntervalHours} hourly window. Administration is blocked — contact the prescriber.`;
            }
            return '';
        },
        // Only "N Hourly" frequencies (e.g. "4 Hourly") have a clean single-gap meaning as a minimum
        // interval between PRN doses - other frequency shorthands (BD, TDS, QID, Daily, etc.) don't
        // translate to one, so this check is skipped for those.
        frequencyIntervalHours() {
            const shorthand = this.selectedPRN?.frequency_shorthand;
            if (!shorthand || !shorthand.toLowerCase().includes('hourly')) return null;
            const hours = parseInt(shorthand.split(' ')[0], 10);
            return isNaN(hours) ? null : hours;
        },
        // True when there IS a last actual administration but its timestamp couldn't be parsed -
        // distinct from "no prior administration at all", which is a safe/no-op case.
        hasUnverifiableLastAdministrationTime() {
            const lastAdmin = this.actualAdministrations[0];
            if (!lastAdmin?.administered_at) return false;
            return isNaN(new Date(lastAdmin.administered_at).getTime());
        },
        lastAdministrationTime() {
            const lastAdmin = this.actualAdministrations[0];
            if (!lastAdmin?.administered_at) return null;
            const date = new Date(lastAdmin.administered_at);
            return isNaN(date.getTime()) ? null : date;
        },
        // Whether the last dose was given within the same scheduled window implied by the prescribed
        // frequency (e.g. re-administering only 1 hour after a "4 Hourly" dose) - independent of the
        // max-times-per-day check above, since a PRN can be under its daily max and still be given
        // again too soon. Marking that prior dose "ineffective" doesn't change its timestamp, so it
        // cannot be used to bypass this either.
        isWithinScheduledWindow() {
            if (this.frequencyIntervalHours === null || !this.lastAdministrationTime) return false;
            const hoursSinceLastDose = (Date.now() - this.lastAdministrationTime.getTime()) / (1000 * 60 * 60);
            return hoursSinceLastDose < this.frequencyIntervalHours;
        },
        dangerWarningMessage() {
            if (this.isOutsideInrRange) {
                return `WARNING: Latest INR (${this.enteredReading}) is outside the prescribed safe range (${this.inrRangeMin ?? '–'}–${this.inrRangeMax ?? '–'}). Please verify before administering and notify the prescriber if required.`;
            }
            if (!this.isS8 && this.isOverMaxFrequency) {
                return `WARNING: This medication has already been administered ${this.selectedPRN.max_times_per_day} time(s) in the last 24 hours, within its prescribed maximum frequency. Please confirm this additional dose is clinically appropriate before continuing.`;
            }
            if (!this.isS8 && this.isWithinScheduledWindow) {
                return `WARNING: This medication was last administered at ${this.lastAdministrationTime.toLocaleString('en-AU')}, within its prescribed ${this.frequencyIntervalHours} hourly window. Are you sure you want to administer again so soon?`;
            }
            return '';
        },
        // Refused/omitted/withheld events (see actualAdministrations) don't count toward the daily
        // dose total.
        dailydose() {
            let amount_administered = 0
            this.actualAdministrations.forEach(admin => {
                amount_administered += parseFloat(admin.quantity);
            })
            return amount_administered
        },
        doseContainerQty(){

            let containerConstant = this.selectedPRN?.container_constant ?? 1
            let myQty = parseFloat(this.enteredDose / containerConstant);

            //this.doseContainerQty = myQty.toFixed(2);

            //this.discardAmount = parseFloat(Math.ceil(myQty) - myQty);

            return myQty.toFixed(2);
        }

    },
    watch: {
        enteredReading() {
            this.acknowledgeDangerReading = false;
        }
    },
    mounted() {
        if (!this.adminSubmission.length) {
            console.log('HITTING THE IF ON MOUNT')
            this.payload = {...this.adminSubmission};
        } else {
            console.log('HITTING THE ELSE ON MOUNT')
            this.payload = this.adminSubmission;
        }
        if(this.selectedPRN.stock_items && this.selectedPRN.stock_items.length){
            
            this.selectedPRN.stock_items.forEach(item=>{
                console.log('got stock items', this.selectedPRN.stock_items)
                item.name = item.alias.name;
            })
            
            
            this.selected_stock_item = this.selectedPRN.stock_items[0];
        }
        this.recommendedSlidingDose()
    }
}
</script>

<style lang="scss">
@import "../../assets/css/main.scss";

.icon-container {
    width: 282px;
    height: 240px;
    left: 25px;
    background: #94D6D0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-circle {
    border-radius: 50%;
    height: 131px;
    width: 131px;
    background: #00B2A2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.small-input {
    span {
        width: 50%;
        input {
            width:50%;
        }
    }
    display: flex;
    align-items: flex-start;
    flex-direction: column;
}

.icon-circle-item {
    width: 75px;
}

.doc-grid-container {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-gap: 10px;
}

.grey-container {
    background-color: #f3f4f4;
    height: 100%;
    border-radius: 6px;
    padding: 20px;
    text-align: left;
    p {
        margin-bottom: 10px !important;
        font-size: 15px;
    }
}

.doc-item {
    padding: 3px;
    background-color: white;
    color: $error;
    border-radius: 6px;
    border: 2px solid $error;
    cursor: pointer;
    width: 186px;
    height: 50px;
    font-size: 15px;
    font-weight: bold;
}

.selected-doc-item {
    background-color: $error;
    color: white;
}

 

 

  

.right-form-section-drug-entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    input {
        background-color: $babyblue;
    }
}

 

.drug-entry-transfer {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    border-collapse: collapse;

    p {
        margin: 0;
        text-align: left;
        padding: 0 15px;
    }

    background-color: $grey;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-bottom: 5px solid white;
    border-radius: 4px;
}


.blue-button {
    background-color: $strongblue !important;
    padding: 5px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0;
    color: white;
}

.right-form-section-panel {
    padding: 0 20px;
}

.full-width-verify.verification-form {
    grid-template-columns: 1fr 1fr;

    div {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
}

.selected-location {
    background-color: $complete;
    color: white;
}

.selected-hollow-button {
    background-color: $strongblue;
    color: white;
}
</style>
